import lookingForWealth from 'assets/images/lookingForWealth.jpeg';
import lookingForWealthOverview from 'assets/images/booksOverview/lookingForWealth.png';

import {
  ONLY_PURCHASE,
  LOGIN,
  ADDRESS,
  PAYMENT,
  PREMIUM_OFFER,
  THANKS,
  PASSWORD,
  FIRST_NAME,
  LAST_NAME,
  ZIP_CODE,
  CITY,
  COUNTRY,
  EMAIL,
  FLIP_BOOK,
  PRINTED_BOOK,
  SMART_BOOKS,
  FLIP_BOOKS,
} from '../const';

const lookForHealth = {
  book: {
    id: 'suche-nach-reichtum',
    format: SMART_BOOKS,
    formats: [SMART_BOOKS, FLIP_BOOKS],
    title: 'In search of wealth',
    subtitle: 'Revelations from the world of risks and returns',
    price: [32, 39],
    introductions: [
      {
        type: 'textWithList',
        text: 'Investing money is not difficult',
        list: ['Lack of basic knowledge of money and finance', 'Fairy tale and fantasy world surrounding money investment'],
      },
      'In Revelations the author shows bluntly',
      'The book is an entertaining read for every investor with an inquisitive mind',
      {
        type: 'textWithList',
        text: 'The hope of making a fast buck on the stock exchange is omnipresent',
        list: ['Prof. Dr. Heinz Zimmermann, University of Basel, author of Finance Compact Plus'],
      },
      {
        type: 'textWithList',
        text: 'Money, pensions and investments',
        list: ['Mark Dittli, Editor-in-Chief of The Market'],
      },
      {
        type: 'textWithList',
        text: 'For decades probably the most distinguished educator in Switzerland',
        list: ['Dr. Pirmin Hotz, owner of the asset management firm of the same name in Baar'],
      },
    ],
    image: lookingForWealth,
    overviewImg: lookingForWealthOverview,
  },
  bookIds: [24, 25, 26],
  getDefaultOption: ({ isPremium, isBasic }) => (isBasic && 1) || (!isPremium && 2) || 0,
  getDefaultStrictMode: ({ isPremium, isBasic }) => Boolean(isBasic || isPremium),
  orderOptions: [PRINTED_BOOK, FLIP_BOOK],
  purchases: [
    {
      id: 1,
      name: 'Fintool Premium Subscriber',
      tasks: {
        [LOGIN]: () => ({
          banner: {
            title: 'Fintool Premium Subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [32, 39],
            propositions: ['Printed book'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [EMAIL, PASSWORD],
            submitButton: 'Login',
            showAdb: false,
          },
          nextStep: 1,
        }),
        [ADDRESS]: () => ({
          banner: {
            title: 'Fintool Premium Subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [32, 39],
            propositions: ['Printed book'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [ADDRESS, ZIP_CODE, CITY, COUNTRY],
            submitButton: 'Continue',
            showAdb: false,
          },
          navigation: '1/2',
          nextStep: 2,
        }),
        [PAYMENT]: () => ({
          banner: {
            title: 'Fintool Premium Subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [32, 39],
            propositions: ['Printed book'],
          },
          form: { withPromoCode: false },
          navigation: '2/2',
          prevStep: 1,
          nextStep: 3,
          shouldSignUp: false,
          subscribeId: null,
          productId: 24,
        }),
        [THANKS]: () => ({
          form: {
            title: 'Your order is on its way',
            description:
              'Thank you for your order. The book is on its way to you. Take advantage of the Fintool Premium offer and expand your money knowledge in one of our courses.',
            button: { name: 'To the Fintool Academy', url: '/akademie' },
          },
        }),
      },
    },
    {
      id: 2,
      name: 'Fintool Basic subscriber',
      tasks: {
        [LOGIN]: () => ({
          banner: {
            title: 'Fintool Basic subscriber',
            price: 'PriceCHF',
            priceValues: [39],
            propositions: ['Printed book'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [EMAIL, PASSWORD],
            submitButton: 'Login',
            showAdb: false,
          },
          nextStep: 1,
        }),
        [ADDRESS]: () => ({
          banner: {
            title: 'Fintool Basic subscriber',
            price: 'PriceCHF',
            priceValues: [39],
            propositions: ['Printed book'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [ADDRESS, ZIP_CODE, CITY, COUNTRY],
            submitButton: 'Continue',
            showAdb: false,
          },
          navigation: '1/3',
          nextStep: 2,
        }),
        [PREMIUM_OFFER]: () => ({
          banner: {
            title: 'Fintool Basic subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 139],
            propositions: ['Printed book', '12 months Fintool-Premium'],
          },
          form: {
            title: 'Switch to Fintool-Premium now and get the book for free',
            priceDescription: 'If you decide now on a Fintool premium annual subscription for',
            priceValues: [100, 39],
            yesButton: 'Yes, buy for',
            noButton: 'Continue without Premium',
          },
          navigation: '2/3',
          prevStep: 1,
          nextStep: 3,
        }),
        [PAYMENT]: (wishPremium) => ({
          banner: {
            title: wishPremium ? 'Fintool Premium Subscriber' : 'Fintool Basic subscriber',
            price: wishPremium ? 'PriceCHF/insteadCHF' : 'PriceCHF',
            priceValues: wishPremium ? [100, 139] : [39],
            propositions: wishPremium ? ['Printed book', '12 months Fintool-Premium'] : ['Printed book'],
          },
          form: { withPromoCode: false },
          navigation: '3/3',
          prevStep: 2,
          nextStep: 4,
          shouldSignUp: false,
          subscribeId: wishPremium ? 6 : null,
          productId: wishPremium ? 25 : 26,
        }),
        [THANKS]: () => ({
          form: {
            title: 'Your order is on its way',
            description:
              'Thank you for your order. The book is on its way to you. Take advantage of the Fintool Premium offer and expand your money knowledge in one of our courses.',
            button: { name: 'To the Fintool Academy', url: '/akademie' },
          },
        }),
      },
    },
    {
      id: 3,
      name: 'Not a Fintool subscriber and would like to order the book',
      tasks: {
        [ONLY_PURCHASE]: () => ({
          banner: {
            title: 'Not a Fintool subscriber',
            price: 'PriceCHF',
            priceValues: [39],
            propositions: ['Printed book'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [FIRST_NAME, LAST_NAME, ADDRESS, ZIP_CODE, CITY, COUNTRY, EMAIL],
            submitButton: 'Continue',
            showAdb: false,
          },
          navigation: '1/3',
          nextStep: 1,
        }),
        [PREMIUM_OFFER]: () => ({
          banner: {
            title: 'Not a Fintool subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 139],
            propositions: [
              'Printed book',
              'Regularly new videos by e-mail',
              'Unlimited access to video library',
              'Access to the entire course offering',
              'Unlimited access to the forums',
              'Knowledge reviews',
              'No advertising breaks',
            ],
          },
          form: {
            title: 'Get Fintool Premium now and get the book for free',
            priceDescription: 'If you decide now on a Fintool premium annual subscription for',
            priceValues: [100, 39],
            yesButton: 'Yes, buy for',
            noButton: 'Order book only',
          },
          navigation: '2/3',
          prevStep: 0,
          nextStep: [2, 3],
        }),
        [PASSWORD]: () => ({
          banner: {
            title: 'Fintool Premium Subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 139],
            propositions: ['Printed book', '12 months Fintool-Premium'],
          },
          form: {
            title: 'Set a password for your Fintool account',
            showSubscribeDescription: false,
            inputs: [PASSWORD],
            submitButton: 'Register',
            showAdb: true,
          },
          navigation: '3/4',
          prevStep: 1,
          nextStep: 3,
        }),
        [PAYMENT]: (wishPremium) => ({
          banner: {
            title: wishPremium ? 'Fintool Premium Subscriber' : 'Not a Fintool subscriber',
            price: wishPremium ? 'PriceCHF/insteadCHF' : 'PriceCHF',
            priceValues: wishPremium ? [100, 139] : [39],
            propositions: wishPremium ? ['Printed book', '12 months Fintool-Premium'] : ['Printed book'],
          },
          form: { withPromoCode: false },
          navigation: wishPremium ? '4/4' : '3/3',
          prevStep: wishPremium ? 2 : 1,
          nextStep: 4,
          shouldSignUp: wishPremium,
          subscribeId: wishPremium ? 6 : null,
          productId: wishPremium ? 25 : 26,
        }),
        [THANKS]: (wishPremium) => ({
          form: {
            title: 'Your order is on its way',
            description: wishPremium
              ? 'Thank you for your order. The book is on its way to you. Take advantage of the Fintool Premium offer and expand your money knowledge in one of our courses.'
              : 'Would you like to get to know Fintool? Take a look at our latest videos in the video studio',
            button: {
              name: wishPremium ? 'To the Fintool Academy' : 'To the video studio',
              url: wishPremium ? '/akademie' : '/videos',
            },
          },
        }),
      },
    },
  ],
};

export default lookForHealth;
